import { RootState } from '@/store/interfaces/rootState';
import authModule from '@/store/modules/auth';
import bankAccountTypeModule from '@/store/modules/bankAccountType';
import branchesModule from '@/store/modules/branches';
import commercesModule from '@/store/modules/commerces';
import companyUserModule from '@/store/modules/companyUser';
import configurationModule from '@/store/modules/configurations';
import operationTypeModule from '@/store/modules/operationType';
import locationModule from '@/store/modules/location';
import resourcesModule from '@/store/modules/resources';
import permissionGroupModule from '@/store/modules/permissionGroup';
import paymentMethodModule from '@/store/modules/paymentMethod';
import payoutMethodModule from '@/store/modules/payoutMethod';
import payoutPixTypeModule from '@/store/modules/payoutPixType';
import paymentModeModule from '@/store/modules/paymentMode';
import paymentStatusModule from '@/store/modules/paymentStatus';
import payoutStatusModule from '@/store/modules/payoutStatus';
import profileModule from '@/store/modules/profile';
import remotePaymentModule from '@/store/modules/remotePayment';
import transactionsModule from '@/store/modules/transactions';
import withdrawals from '@/store/modules/withdrawals';
import padipix from '@/store/modules/padipix';
import salesReportModule from '@/store/modules/salesReport';
import balanceModule from '@/store/modules/balance';
import processPayoutsModule from '@/store/modules/processPayouts';
import payoutConfigurationModule from '@/store/modules/payoutConfiguration';
import credentialTypeModule from '@/store/modules/credentialType';
import RootTypes from '@/store/types/root';
import Vue from 'vue';
import Vuex, { GetterTree, MutationTree } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Sentry
import { envEvaluation } from '@/config/sentry/enviromentEvaluation';
import { configureScope, setUser } from '@sentry/vue';

Vue.use(Vuex);

const state: RootState = {
  startprocess: false,
};
const mutations: MutationTree<RootState> = {
  [RootTypes.mutations.SET_START_PROCESS]: state => {
    state.startprocess = true;
  },
  [RootTypes.mutations.SET_END_PROCESS]: state => {
    state.startprocess = false;
  },
};
const getters: GetterTree<RootState, RootState> = {
  [RootTypes.getters.GET_START_PROCESS]: state => {
    return state.startprocess;
  },
};
export default new Vuex.Store<RootState>({
  state,
  getters,
  mutations,
  modules: {
    authModule,
    bankAccountTypeModule,
    branchesModule,
    commercesModule,
    companyUserModule,
    configurationModule,
    operationTypeModule,
    locationModule,
    resourcesModule,
    permissionGroupModule,
    paymentMethodModule,
    payoutMethodModule,
    payoutPixTypeModule,
    paymentModeModule,
    paymentStatusModule,
    payoutStatusModule,
    profileModule,
    remotePaymentModule,
    transactionsModule,
    withdrawals,
    padipix,
    salesReportModule,
    balanceModule,
    processPayoutsModule,
    payoutConfigurationModule,
    credentialTypeModule,
  },
  plugins: [
    createPersistedState({
      key: 'DC',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reducer(val: any) {
        if (!val.authModule.token) {
          if (envEvaluation()) {
            configureScope(scope => scope.setUser(null));
          }
          return {};
        }
        if (envEvaluation()) {
          setUser({ id: val.authModule.currentUser.id, });
        }
        return val;
      },
    })
  ],
});
